import { z } from "zod"
import { Network, Token } from "@/config/tokens"
import { InvoiceStatus } from "@/api/invoices"

export const invoiceSchema = z.object({
  customerId: z
    .string({ invalid_type_error: "Required" })
    .min(1, "Customer is required"),
  date: z.date(),
  dueDate: z.date(),
  networks: z.array(z.nativeEnum(Network)).min(1),
  token: z.nativeEnum(Token),
  items: z
    .array(
      z.object({
        description: z.string().min(1, "Required"),
        unitValue: z
          .string()
          .min(1, "Required")
          .transform((v) => parseFloat(v)),
        quantity: z
          .string()
          .min(1, "Required")
          .transform((v) => parseFloat(v)),
      }),
    )
    .min(1, "At least one item is required"),
  status: z.nativeEnum(InvoiceStatus),
  sendToEmails: z
    .array(z.string())
    .transform((arr) => arr.filter((str) => str !== "")),
})
